import { Helper } from "../helpers/helper";
import { CustomValidatorsUtility } from "./forms/custom-validators.utility";
import { FormWebhooksUtility } from "./forms/form-webhooks.utility";
import { UrlUtility } from "./url.utility";
import * as FormFieldsUtility from "./forms/form-fields.utility";
import * as FormDragDropUtility from "./forms/form-drag-drop.utility";
import { FormItem } from "../models/imis.models";
import { DataSourcesUtility } from "./dataSources.utility";

function getElementByTableField(fieldName: string, tableName?: string): HTMLElement {
    let element: HTMLElement = null;
    let selectorParts = [tableName, fieldName].filter(function (part) { return !Helper.isStringNullOrEmpty(part) });
    let jPossibleElements = jQuery("[id$=_" + selectorParts.join("_") + "]");
    jPossibleElements.each(function () {
        if (this.validationGroup == null) {
            element = this;
        }
    });

    return element;
}

function convertCheckboxListToMultiSelect(fieldName: string, tableName: string, multiSelectId: string = fieldName + "_MULTISELECT") {
    let jElement = jQuery(getElementByTableField(fieldName, tableName));
    if (jElement.length > 0) {
        let jSelect = jElement.siblings("#" + multiSelectId);
        jSelect.remove();

        // setup multi select
        let alreadySelectedOptions = [];
        jSelect = jQuery("<select class='checkbox-list-to-multiselect' multiple></select>");
        jSelect.attr("id", multiSelectId);

        jElement.find("input[type=checkbox]").each(function () {
            // get the checkbox and its id and value
            let jCheckbox = jQuery(this);
            let optionId = jCheckbox.attr("id");
            let optionValue = jCheckbox.val();
            if (jCheckbox.prop("checked")) {
                alreadySelectedOptions.push(optionValue);
            }

            let jLabel = jCheckbox.siblings("label[for=" + optionId + "]");
            // clear out any child elements that wont render in the option tag
            let optionText = jLabel.clone().children().remove().end().text();
            // set value as text if empty
            if (Helper.isStringNullOrEmpty(optionText)) {
                optionText = optionValue.toString();
            }

            let jOption = jQuery("<option></option>");
            jOption.val(optionValue).data("id", optionId).text(optionText);

            jSelect.append(jOption);
        });

        // preset selected values
        jSelect.val(alreadySelectedOptions);

        // set on change to update all checkboxes
        jSelect.on("change", function () {
            jSelect.find("option").each(function () {
                let jOption = jQuery(this);
                let jCheckbox = jQuery("#" + jOption.data("id"));
                jCheckbox.prop("checked", jOption.prop("selected")).trigger("change");
            });
        });

        jElement.hide();
        jSelect.insertBefore(jElement);
    }
}

function isFormSubmissionSuccess(): boolean {
    let formSubmissionSuccess = false;
    let formIsOnCloud = jQuery("[id$=_imisVersion]").length > 0;
    
    let jSuccessMessage = jQuery(".vaMessageAsi .AsiSuccess:not(.AsiError)");
    let successMessageCssVisibilityValue = jSuccessMessage.css("visibility");
    
    let isSuccessMessageVisible = jSuccessMessage.length > 0 && successMessageCssVisibilityValue != "hidden";
    if (!formIsOnCloud) {
        formSubmissionSuccess = isSuccessMessageVisible;
    } else {
        // two possible ways
        let isSavedParameterSet = UrlUtility.findUrlParameter("Saved") == "true";

        formSubmissionSuccess = isSavedParameterSet || isSuccessMessageVisible;
    }

    return formSubmissionSuccess;
}

async function getFormRecord(formId?: string | number): Promise<FormItem> {
    let currentFormId = formId || UrlUtility.findUrlParameter("FormId");
    let formData: FormItem = await DataSourcesUtility.getDataSourceRecord("FormDesignerLibrary", [currentFormId]);

    return formData;
}

async function updateFormRecord(data: FormItem) {
    let id = VAIMISUtilityV2.Url.findUrlParameter("formid");
    await VAIMISUtilityV2.Rest.restApiSendData("/api/FormDesignerLibrary/" + id, data, "PUT");
}

export {
    getElementByTableField,
    convertCheckboxListToMultiSelect,
    isFormSubmissionSuccess,
    getFormRecord,
    updateFormRecord,
    FormFieldsUtility as Field,
    CustomValidatorsUtility as CustomValidator,
    FormWebhooksUtility as Webhook,
    FormDragDropUtility as DragDrop,
};
